import script from "./SubPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SubPanel.vue?vue&type=style&index=0&id=28b36410&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b36410"]])

export default __exports__